import { render } from "./SubDetails.vue?vue&type=template&id=0130962e&scoped=true"
import script from "./SubDetails.vue?vue&type=script&lang=js"
export * from "./SubDetails.vue?vue&type=script&lang=js"

import "./SubDetails.vue?vue&type=style&index=0&id=0130962e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0130962e"]])

export default __exports__